// Copyright (c) Frisbii GmbH. All rights reserved.
"use strict";

const PgSystemSettingsController = function ($scope, $http, PgSystemSettings) {
    
    $scope.settings = {};
    
    function loadData() {
        if (!$scope.adminOrInRole([]))
            return;
        
        $scope.settings = PgSystemSettings.get();
    }

    loadData();

    function saveSettings() {
        $scope.settings.$update({}, function () {
            $scope.notify("success", "saved successfully");
        });
    }

    $scope.saveSettings = function () {
        $scope.confirm('Save settings', 'Are you sure you want to save new settings?', saveSettings);
    };
};
PgSystemSettingsController.$inject = ["$scope", "$http", "PgSystemSettings"];
